// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change_name_input[data-v-5be94c30] {\n  width: 100%;\n  padding-left: 1em;\n  color: white;\n  background-color: #272727;\n  border: 1px solid #4A4A4A;\n  border-radius: 3px;\n  height: 2.5em;\n}", ""]);
// Exports
module.exports = exports;
